export const FIPS_TO_STATES = {
  '01': {
    name: 'Alabama',
    code: 'AL',
  },
  '02': {
    name: 'Alaska',
    code: 'AK',
  },
  '04': {
    name: 'Arizona',
    code: 'AZ',
  },
  '05': {
    name: 'Arkansas',
    code: 'AR',
  },
  '06': {
    name: 'California',
    code: 'CA',
  },
  '08': {
    name: 'Colorado',
    code: 'CO',
  },
  '09': {
    name: 'Connecticut',
    code: 'CT',
  },
  '10': {
    name: 'Delaware',
    code: 'DE',
  },
  '11': {
    name: 'District Of Columbia',
    code: 'DC',
  },
  '12': {
    name: 'Florida',
    code: 'FL',
  },
  '13': {
    name: 'Georgia',
    code: 'GA',
  },
  '15': {
    name: 'Hawaii',
    code: 'HI',
  },
  '16': {
    name: 'Idaho',
    code: 'ID',
  },
  '17': {
    name: 'Illinois',
    code: 'IL',
  },
  '18': {
    name: 'Indiana',
    code: 'IN',
  },
  '19': {
    name: 'Iowa',
    code: 'IA',
  },
  '20': {
    name: 'Kansas',
    code: 'KS',
  },
  '21': {
    name: 'Kentucky',
    code: 'KY',
  },
  '22': {
    name: 'Louisiana',
    code: 'LA',
  },
  '23': {
    name: 'Maine',
    code: 'ME',
  },
  '24': {
    name: 'Maryland',
    code: 'MD',
  },
  '25': {
    name: 'Massachusetts',
    code: 'MA',
  },
  '26': {
    name: 'Michigan',
    code: 'MI',
  },
  '27': {
    name: 'Minnesota',
    code: 'MN',
  },
  '28': {
    name: 'Mississippi',
    code: 'MS',
  },
  '29': {
    name: 'Missouri',
    code: 'MO',
  },
  '30': {
    name: 'Montana',
    code: 'MT',
  },
  '31': {
    name: 'Nebraska',
    code: 'NE',
  },
  '32': {
    name: 'Nevada',
    code: 'NV',
  },
  '33': {
    name: 'New Hampshire',
    code: 'NH',
  },
  '34': {
    name: 'New Jersey',
    code: 'NJ',
  },
  '35': {
    name: 'New Mexico',
    code: 'NM',
  },
  '36': {
    name: 'New York',
    code: 'NY',
  },
  '37': {
    name: 'North Carolina',
    code: 'NC',
  },
  '38': {
    name: 'North Dakota',
    code: 'ND',
  },
  '39': {
    name: 'Ohio',
    code: 'OH',
  },
  '40': {
    name: 'Oklahoma',
    code: 'OK',
  },
  '41': {
    name: 'Oregon',
    code: 'OR',
  },
  '42': {
    name: 'Pennsylvania',
    code: 'PA',
  },
  '44': {
    name: 'Rhode Island',
    code: 'RI',
  },
  '45': {
    name: 'South Carolina',
    code: 'SC',
  },
  '46': {
    name: 'South Dakota',
    code: 'SD',
  },
  '47': {
    name: 'Tennessee',
    code: 'TN',
  },
  '48': {
    name: 'Texas',
    code: 'TX',
  },
  '49': {
    name: 'Utah',
    code: 'UT',
  },
  '50': {
    name: 'Vermont',
    code: 'VT',
  },
  '51': {
    name: 'Virginia',
    code: 'VA',
  },
  '53': {
    name: 'Washington',
    code: 'WA',
  },
  '54': {
    name: 'West Virginia',
    code: 'WV',
  },
  '55': {
    name: 'Wisconsin',
    code: 'WI',
  },
  '56': {
    name: 'Wyoming',
    code: 'WY',
  },
} as const

export const STATES_ABBREVIATIONS: { [key: string]: string } = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
} as const
